export function getNextDay(amount: number, initialDate?: null | Date | string) {
    var day = new Date(initialDate || new Date())
    day.setDate(day.getDate() + amount)
    return day.toISOString().split('T')[0]
}
